import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';
import {
    AppendFileTransferRequestDetailsPayload,
    CreateFileTransferRequestPayload,
    ImportLegacyRawTransferPayload,
    UpdateFileTransferRequestPayload,
} from '../../../../types/StudioFileManager';

const CreateSession = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.StudioFileManagerCommandURL.CreateSession,
        method: RequestType.POST,
        data,
    });

const CreateFileTransferRequest = (data: CreateFileTransferRequestPayload): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.StudioFileManagerCommandURL.CreateFileTransferRequest,
        method: RequestType.POST,
        data,
    });

const AppendFileTransferRequestDetails = (data: AppendFileTransferRequestDetailsPayload): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.StudioFileManagerCommandURL.AppendFileTransferRequestDetails,
        method: RequestType.POST,
        data,
    });

const UpdateFileTransferRequest = (data: UpdateFileTransferRequestPayload): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.StudioFileManagerCommandURL.UpdateFileTransferRequest,
        method: RequestType.POST,
        data,
    });

const ImportLegacyRawTransfer = (data: ImportLegacyRawTransferPayload): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.StudioFileManagerCommandURL.ImportLegacyRawTransfer,
        method: RequestType.POST,
        data,
    });

const ImportLegacyRetouchTransfer = (data: any = {}): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.StudioFileManagerCommandURL.ImportLegacyRetouchTransfer,
        method: RequestType.POST,
        data,
    });

export const StudioFileManagerCommand = {
    CreateSession,
    CreateFileTransferRequest,
    AppendFileTransferRequestDetails,
    UpdateFileTransferRequest,
    ImportLegacyRawTransfer,
    ImportLegacyRetouchTransfer,
};
